import { render, staticRenderFns } from "./TermsAndConditionsCovid.vue?vue&type=template&id=893053fa&scoped=true"
import script from "./TermsAndConditionsCovid.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsCovid.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsCovid.vue?vue&type=style&index=0&id=893053fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893053fa",
  null
  
)

export default component.exports